module.exports = __webpack_public_path__ + "static/media/dynex.72ef5d82.png";